import { CSVUploadPage } from '@tom-ui/planning'
import type { IImportContainerRequest, IYardBlock } from '@tom-ui/planning'
import { containersService, yardBlockService } from '@tom-ui/yard'
import { FC } from 'react'

export const CSVUploadWrapper: FC = () => {
  return (
    <CSVUploadPage
      getYardBlocksByNames={(names: string[]) => yardBlockService.getYardBlocksByNames(names)}
      stackIn={(requests: IImportContainerRequest[]) => containersService.importBatch(requests)}
    />
  )
}
